var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('BaseBreadCrumbs'), _vm.getHours.length <= 0 ? _c('div', {
    staticClass: "title font-weight-light text-center",
    staticStyle: {
      "align-self": "center"
    }
  }, [_vm._v(" Ingen arbeidstimer funnet ")]) : _vm._e(), _vm.showHoursDetailsModal ? _c('BaseModal', [_c('TheHoursDetailsModal', {
    on: {
      "close": function ($event) {
        _vm.showHoursDetailsModal = false;
      }
    }
  })], 1) : _c('v-card', {
    attrs: {
      "elevation": 1
    }
  }, [_c('v-card-title', [_c('v-row', [_c('v-col', {
    staticClass: "pt-0 pb-0",
    attrs: {
      "cols": "5"
    }
  }, [_vm._v(" Mine arbeidstimer ")]), _c('v-col', {
    staticClass: "pt-0 pb-0 d-flex justify-end",
    attrs: {
      "cols": "5"
    }
  }, [_c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "small": "",
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": _vm.gropuNone
    }
  }, [_vm._v(" Fjern gruppering ")]), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "small": "",
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": _vm.gropuDate
    }
  }, [_vm._v(" Grupper etter dato ")]), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "small": "",
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": _vm.groupCourse
    }
  }, [_vm._v(" Grupper etter kurs ")])], 1), _c('v-col', {
    staticClass: "pt-0 pb-0",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "append-icon": "mdi-magnify",
      "label": "Søk",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: _vm.search,
      callback: function ($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    attrs: {
      "headers": _vm.tableHeaders,
      "items": _vm.hourItems,
      "sort-by": "id",
      "item-key": "id",
      "sort-desc": false,
      "search": _vm.search,
      "group-by": _vm.group,
      "data-cy": "hoursTable"
    },
    on: {
      "click:row": _vm.handleHour
    },
    scopedSlots: _vm._u([{
      key: "item.registeredHours",
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('v-chip', {
          attrs: {
            "color": _vm.getColor(item.registeredHours),
            "dark": "",
            "outlined": ""
          }
        }, [item.registeredHours !== '' ? _c('span', [_vm._v(" " + _vm._s(item.registeredHours) + " ")]) : _c('span', [_vm._v(" Ikke utfylt ")])])];
      }
    }, {
      key: "(item",
      fn: function () {
        return [_c('v-chip', {
          attrs: {
            "color": _vm.getColor(_vm.item.approvedHours),
            "dark": "",
            "outlined": ""
          }
        }, [_vm.item.approvedHours !== '' ? _c('span', [_vm._v(" " + _vm._s(_vm.item.approvedHours) + " ")]) : _c('span', [_vm._v(" Ikke godkjent ")])])];
      },
      proxy: true
    }], null, true)
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }